import { runPendingAnalyticalRequests } from "./events/eventRequests.js";
import { isBrowser } from "./utils/index.js";
export class KlevuConfig {
    constructor(config) {
        var _a;
        this.cacheMaxTTL = 600000;
        this.eventsApiV1Url = "https://stats.ksearchnet.com/analytics/";
        this.eventsApiV2Url = "https://stats.ksearchnet.com/analytics/collect";
        this.recommendationsApiUrl = "https://config-cdn.ksearchnet.com/recommendations/";
        this.moiApiUrl = "https://moi-ai.ksearchnet.com/";
        this.disableClickTracking = false;
        this.apiKey = config.apiKey;
        this.url = config.url;
        if (config.moiApiUrl) {
            this.moiApiUrl = config.moiApiUrl;
        }
        if (config.cacheMaxTTL) {
            this.cacheMaxTTL = config.cacheMaxTTL;
        }
        if (config.axios) {
            this.axios = config.axios.create();
        }
        if (config.eventsApiV1Url) {
            this.eventsApiV1Url = config.eventsApiV1Url;
        }
        if (config.eventsApiV2Url) {
            this.eventsApiV2Url = config.eventsApiV2Url;
        }
        if (config.recommendationsApiUrl) {
            this.recommendationsApiUrl = config.recommendationsApiUrl;
        }
        this.disableClickTracking = (_a = config.disableClickTrackStoring) !== null && _a !== void 0 ? _a : false;
    }
    static init(config) {
        KlevuConfig.default = new KlevuConfig(config);
        runPendingAnalyticalRequests();
    }
    static getDefault() {
        if (!KlevuConfig.default) {
            throw new Error("Configuration missing");
        }
        return KlevuConfig.default;
    }
}
KlevuConfig.default = loadFromGlobal();
function loadFromGlobal() {
    if (!isBrowser()) {
        return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cfg = window.KlevuConfig;
    if (!cfg) {
        return undefined;
    }
    return new KlevuConfig(cfg);
}
